const hostedFamilyFortuneVideoUrl =
  'https://sims4vis.games.cg.jku.at/src/video/sims4.mp4'

function isLocalBrowserHost() {
  if (typeof window === 'undefined' || !window.location) return true
  const hostname = window.location.hostname
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '0.0.0.0' ||
    hostname === ''
  )
}

function getFamilyFortuneVideoPath() {
  return isLocalBrowserHost()
    ? '../../src/video/sims4.mp4'
    : hostedFamilyFortuneVideoUrl
}

export const familyFortuneDataset = {
  id: 'family-fortune',
  matchId: 'Match11',
  label: 'The Sims 4 Family Fortune',
  storyScriptFile: 'Match11/simsTestFull.json',
  participantsPath: '../../data/json/Match11/sims2.json',
  eventsPath: '../../data/json/Match11/Story_Events_DataFull.json',
  videoPath: getFamilyFortuneVideoPath(),
}

export const activeDataset = familyFortuneDataset

export function getDatasetAuthoringStorageKey(dataset = activeDataset) {
  return `istoryline_authoring_annotations_v1:${dataset.id}`
}
